<div class="header-bar">
  <div class="flex">
    <div class="flex-shrink-1">
      <h1>Customer Priority Management</h1>
    </div>
    <div class="flex-shrink-1">
      <i class="fa fa-info-circle info-circle cursor-pointer" (click)="showInfoDialog = true"></i>
    </div>
  </div>
</div>

<div class="content-container">
  <form [formGroup]="filterForm">
    <div class="filterPanel style2023 p-3">
      <div
        class="flex-wrap"
        style="
          grid-gap: 15px;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        "
      >
        <div>
          <p-multiSelect
            formControlName="customerId"
            label="Choose Customer"
            (onChange)="changeCustomerList()"
            class="filter-multiselect narrow-multiselect"
            [options]="customerOptions"
          ></p-multiSelect>
        </div>
        <div>
          <p-multiSelect
            formControlName="departmentId"
            class="filter-multiselect checkbox-top narrow-multiselect"
            (onChange)="changedDepartments()"
            [options]="filteredDepartments(departmentOptions)"
          >
            <ng-template let-item let-i="index" pTemplate="item">
              <div style="display: inline-block">
                <div class="department-line-1">{{ item.label }}</div>
                <div class="department-line-2">{{ item.customerName }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
        <div *ngIf="showTeams">
          <p-multiSelect
            formControlName="teamId"
            class="filter-multiselect checkbox-top narrow-multiselect"
            (onChange)="changedTeams()"
            [options]="filteredTeams(teamOptions)"
          >
            <ng-template let-item let-i="index" pTemplate="item">
              <div style="display: inline-block">
                <div class="department-line-1">{{ item.label }}</div>
                <div class="department-line-2">{{ item.customerName }}</div>
                <div class="department-line-2">{{ item.departmentName }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
        <div>
          <p-multiSelect
            formControlName="amPriorities"
            class="filter-multiselect narrow-multiselect"
            (onChange)="changedAMPriority()"
            [options]="amPriorityOptions"
          ></p-multiSelect>
        </div>
        <div>
          <p-multiSelect
            formControlName="pmChecks"
            class="filter-multiselect narrow-multiselect"
            (onChange)="changedPMChecks()"
            [options]="pmChecksOptions"
          ></p-multiSelect>
        </div>
        <div class="flex-grow-1">
          <p-multiSelect
            formControlName="updatedByUsers"
            class="filter-multiselect narrow-multiselect"
            (onChange)="changedUpdateByUsers()"
            [options]="updateByUserOptions"
          ></p-multiSelect>
        </div>
        <div class="flex align-items-center gap-2">
          <div class="flex align-items-center">
            <p-checkbox
              binary="true"
              formControlName="showTeams"
              class="mx-1"
              (onChange)="changedShowTeams()"
              label="Show Teams"
            ></p-checkbox>
            <button
              pButton
              icon="fa fa-undo"
              class="ui-button-tertiary"
              (click)="resetForm()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <p-table
    #priorityTable
    [value]="sortedFilteredCustomerDepartmentList"
    [rows]="20"
    [paginator]="true"
    [autoLayout]="true"
    class="priority-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="text-left pl-3" pSortableColumn="customerName">Customer</th>
        <th class="text-left pl-3" pSortableColumn="departmentName">Department</th>
        <th *ngIf="showTeams" class="text-left pl-3" pSortableColumn="teamName">Team</th>
        <th pSortableColumn="amCheckPriority">AM Check Priority</th>
        <th pSortableColumn="pmCheckRequired">PM Check Required</th>
        <th pSortableColumn="updated">Date Updated</th>
        <th class="text-left pl-3" pSortableColumn="userId">Updated By User</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr *ngIf="(!showTeams && !item.teamId) || showTeams">
        <td>
          <div class="link-style cursor-pointer" (click)="showCRM(item.customerId)">
            {{ item?.customerName }}
          </div>
        </td>
        <td>{{ item?.departmentName }}</td>
        <td *ngIf="showTeams">{{ item?.teamName || '-' }}</td>
        <td>
          <p-dropdown
            [styleClass]="'no-border-bottom'"
            appendTo="body"
            [(ngModel)]="item.amCheckPriority"
            (ngModelChange)="setValue(item, 'amCheckPriority')"
            [options]="inlinePriorityOptions"
          >
            <ng-template let-item let-i="index" pTemplate="item">
              <div class="priority-item priority-{{ item.value }}">{{ item.label }}</div>
            </ng-template>
            <ng-template let-item let-i="index" pTemplate="selectedItem">
              <div class="priority-item priority-{{ item.value }}">{{ item.label }}</div>
            </ng-template>
          </p-dropdown>
        </td>
        <td class="text-center">
          <input
            [(ngModel)]="item.pmCheckRequired"
            (change)="setValue(item, 'pmCheckRequired')"
            class="priority-checkbox"
            type="checkbox"
            value="{{ item?.pmCheckRequired }}"
          />
        </td>
        <td class="text-center">{{ (item?.updated | datex : 'DD/MM/yy') || 'N/A' }}</td>
        <td>{{ userLookup(item?.userId) || 'N/A' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Customer Priority Information"
  [(visible)]="showInfoDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '650px' }"
>
  <div>
    This page shows department priorities for task monitoring, with checks occurring twice daily:
    one in the morning starting at 10 AM (AM) and another starting at 1 PM (PM). Here's what each
    priority state means:
  </div>

  <div class="section-header">AM Check Priority (Tags)</div>

  <div class="section-block">
    <div class="priority-item priority-grey">Unset Priority</div>
    <div class="explanation">
      If the cell displays as 'Unset' this is a new department that needs to be assigned a priority
      (W1 or W2).
    </div>
  </div>

  <div class="section-block">
    <div class="priority-item priority-1"><strong>W1</strong> Critical Priority</div>
    <div class="explanation">
      Orders from deparments with this AM priority are from high-importance accounts which are top
      priority, requiring immediate attention to detect and resolve issues early in the day.
    </div>
  </div>

  <div class="section-block">
    <div class="priority-item priority-2"><strong>W2</strong> High Priority</div>
    <div class="explanation">
      Orders from departments with this AM priority are important but less urgent than critical
      accounts. These should be monitored closely but with a lower priority.
    </div>
  </div>

  <div class="section-block">
    <div class="priority-item priority-3"><strong>W3</strong> Medium Priority</div>
    <div class="explanation">
      Orders coming from departments with medium priority, should ideally still be checked in the
      morning.
    </div>
  </div>

  <div class="section-block">
    <div class="priority-item priority-4"><strong>W4</strong> Low Priority</div>
    <div class="explanation">
      Orders coming from departments with low priority, should ideally still be checked in the
      morning but can be checked last.
    </div>
  </div>

  <div class="section-header">PM Check Priority (Checkbox)</div>

  <div class="section-block">
    <div><input type="checkbox" /> <span class="block-header">Unselected Checkbox</span></div>
    <div class="explanation">
      Either a new department is pending setup or the internal team has confirmed that no evening
      check is needed.
    </div>
  </div>

  <div class="section-block mb-2">
    <div><input type="checkbox" checked /> <span class="block-header">Selected Checkbox</span></div>
    <div class="explanation">
      The department's orders require an evening review as confirmed by the internal team.
    </div>
  </div>
</p-dialog>
